<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<!--导航-->
			<div class="nav_box">
				<div class="left">
					<a href="https://cordx.com/">
						<img src="https://cordx.com/wp-content/uploads/2022/03/CorDx-logo.svg" />
					</a>
				</div>
				<div class="right">
					<img v-if="!isShow" src="../assets/img/icon_nav.webp" @click="showSlide" />
					<van-icon v-else name="cross" size="0.667rem" color="#0b318f" @click="showSlide" />
				</div>
			</div>
			<!--导航-->
			<!--折叠导航-->
			<div class="slide_box" :class="isShow ? 'height-slide' : ''">
				<a v-for="(value, index) in navData" :href="value.href">
					<div>{{ value.title }}</div>
				</a>
			</div>
			<!--折叠导航-->
			<!--按钮-->
			<div style="">
				<div class="step_box">
					<div class="step_el" @click="choose('English')">
						<div class="tit">English</div>
						<div class="txt">instructions and timer</div>
					</div>
					<div class="step_el" @click="choose('Spanish')">
						<div class="tit">Español</div>
						<div class="txt">instructions and timer</div>
					</div>
					<div class="step_el" @click="choose('Chinese')">
						<div class="tit">中文</div>
						<div class="txt">操作说明和计时器</div>
					</div>
				</div>
			</div>
			<!--按钮-->
			<!-- <div class="lang_box" :class="actived === 'English' ? 'actived' : ''" @click="choose('English')">
				<div class="lang_main">
					<div class="img_box">
						<img src="../assets/img/spain/icon_english.webp" />
					</div>
					<div class="tit">
						English
					</div>
				</div>
			</div>
			<div class="solid"></div>
			<div class="lang_box" :class="actived === 'Spanish' ? 'actived' : ''" @click="choose('Spanish')">
				<div class="lang_main">
					<div class="img_box">
						<img src="../assets/img/spain/icon_spanish.webp" />
					</div>
					<div class="tit">
						Español
					</div>
				</div>
			</div> -->
			<!--pdf-->
			<div class="pdf_box">
				<van-image
				  v-for="(value, index) in imgData"
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="value"
				  @click.stop.prevent="showBig(index)"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
			</div>
			<!--pdf-->
		</div>
		<!--页面开始-->
		<!--遮罩-->
		<!-- <van-dialog v-model="isShowZz" title="Confirm" :showConfirmButton="false" :showCancelButton="false">
			<div class="countdown_box">
				<div class="count_txt">Some browsers have pop-up advertising, which has nothing to do with our company</div>
				<div class="count_btn" ref="toggle1">OK</div>
			</div>
		</van-dialog> -->
		<!--遮罩-->
	</div>
</template>

<script>
	import {
		ImagePreview
	} from "vant";
	export default {
		components: {
			//
		},
		data() {
			return {
				actived: '',
				navData: [{
						title: 'About',
						href: 'https://cordx.com/about'
					},
					{
						title: 'Products',
						href: 'https://cordx.com/product/all'
					},
					{
						title: 'Partnering',
						href: 'https://cordx.com/partnering'
					},
					{
						title: 'Resources',
						href: 'https://cordx.com/resources'
					},
					{
						title: 'Media Room',
						href: 'https://cordx.com/media-room'
					},
					{
						title: 'Careers',
						href: 'https://cordx.com/careers'
					},
					{
						title: 'Contact',
						href: 'https://cordx.com/contact'
					},
				],
				isShow: false,
				imgData: [
					require('@/assets/img/pdf/01.webp'),
					require('@/assets/img/pdf/02.webp'),
					require('@/assets/img/pdf/03.webp'),
					require('@/assets/img/pdf/04.webp'),
					require('@/assets/img/pdf/05.webp'),
					require('@/assets/img/pdf/06.webp'),
					require('@/assets/img/pdf/07.webp'),
					require('@/assets/img/pdf/08.webp'),
					require('@/assets/img/pdf/09.webp'),
					require('@/assets/img/pdf/10.webp'),
					require('@/assets/img/pdf/11.webp'),
					require('@/assets/img/pdf/12.webp'),
					require('@/assets/img/pdf/13.webp'),
					require('@/assets/img/pdf/14.webp'),
					require('@/assets/img/pdf/15.webp'),
					require('@/assets/img/pdf/16.webp'),
					require('@/assets/img/pdf/17.webp'),
					require('@/assets/img/pdf/18.webp'),
					require('@/assets/img/pdf/19.webp'),
					require('@/assets/img/pdf/20.webp'),
					require('@/assets/img/pdf/21.webp'),
				],
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
		},
		watch: {
			//
		},
		methods: {
			//选择语种
			choose(value) {
				let that = this;
				that.actived = value;
				setTimeout(() => {
					if (value === 'English') {
						that.$router.push({
							path: '/important'
						});
					} else if (value === 'Spanish') {
						that.$router.push({
							path: '/spain/stepOne'
						});
					} else if(value === 'Chinese') {
						that.$router.push({
							path: '/chinese/stepOne'
						});
					}
					that.actived = "";
				}, 100);
			},
			//显示/隐藏导航
			showSlide() {
				let that = this;
				that.isShow = !that.isShow;
			},
			//显示大图
			showBig(index) {
				let that = this;
				ImagePreview({
					images: that.imgData,
					startPosition: index,
				});
			}
		},
		beforeDestroy() {
			//
		},
		destroyed() {
			//
		}
	}
</script>
</script>

<style scoped>
	.main_box {
		width: 100%;
		height: 100vh;
	}

	/*导航*/
	.nav_box {
		height: 1.92rem;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f4f4f4;
		position: relative;
		z-index: 1;
		background-color: #ffffff;
	}

	.nav_box .left {
		flex: 1;
		padding-left: 0.3rem;
	}

	.nav_box .right {
		width: auto;
		padding-right: 0.3rem;
	}

	.nav_box .left img {
		max-width: 3rem;
		height: auto;
	}

	.nav_box .right img {
		width: 0.667rem;
		height: auto;
	}

	.slide_box {
		position: absolute;
		z-index: 1;
		width: 100%;
		background-color: #ffffff;
		max-height: 0;
		transition: max-height 0.5s;
		overflow: hidden;
	}

	.height-slide {
		max-height: 1000px;
	}

	.slide_box div {
		padding: 0.4rem 0.53rem;
	}

	.slide_box div {
		color: #000000;
		font-size: 0.5rem;
	}

	.pdf_box {
		width: 100%;
		padding: 0.5rem 0.5rem 0.5rem 0.5rem;
	}

	.pdf_box img {
		width: 100%;
	}

	.main_box .lang_box {
		/* height: 30%; */
		position: relative;
	}

	.lang_box .lang_tit {
		position: absolute;
		font-size: 0.5rem;
		color: #333333;
	}

	.lang_box .lang_main {
		width: 100%;
		height: 100%;
		text-align: center;
		/* display: flex;
	align-items: center; */
		position: relative;
		/* top: -0.5rem; */
	}

	.lang_main .img_box {
		width: 2.8rem;
		margin: 0 auto;
		/* display: inline-block;
	margin-left: 1.5rem;
	margin-right: 0.8rem; */
	}

	.lang_main .img_box img {
		width: 100%;
	}

	.lang_main .tit {
		/* display: inline-block; */
		font-size: 0.53rem;
		color: #333333;
		font-weight: bold;
	}

	.actived {
		background-color: #f6f6f6;
	}

	.solid {
		width: 90%;
		margin: 0 auto;
		border-top: 1px solid #f4f4f4;
	}


	.step_box .step_el {
		background-color: #ffffff;
		margin-bottom: 0.32rem;
		border-radius: 0.32rem;
		box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
		overflow: hidden;
		position: relative;
		border: 1px solid #E9E9E9;
		margin: 0.5rem;
		text-align: center;
		padding: 1.5rem;
		/* border: 1px solid #ff0000; */
	}

	.step_el .tit {
		font-size: 0.6rem;
		font-weight: bold;
		color: #333333;
	}

	.step_el .txt {
		padding-top: 0.15rem;
		color: #999999;
	}
</style>
